module.exports = __webpack_public_path__ + "img/404.49eb1c3f.svg";